import { Capacitor } from "@capacitor/core";

export const AppCfg = {
  env: import.meta.env.VITE_ENV,
  isProd: import.meta.env.VITE_ENV === "production",

  enableGA: true, // import.meta.env.VITE_ENABLE_GA === "true",

  platform: Capacitor.getPlatform(),
  isNative: true, // Capacitor.isNativePlatform(),

  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || "http://localhost:3000",
  clientBaseUrl: import.meta.env.VITE_CLIENT_BASE_URL || "https://garther.app",

  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyC0siHZqs9-7gkGgrnjM2y_ALYKbHZBhVw",
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "garther-develop.firebaseapp.com",
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "garther-develop",
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "garther-develop.firebasestorage.app",
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "519747682916",
    appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:519747682916:web:584d24087e954607099571",
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-YVKG5GG4NW"
  }
} as const;
